import React from 'react';
import VolleyballComp from './Volleyball.component';

class Volleyball extends React.Component {
    componentDidMount() {
        VolleyballComp();
    }
    render() {
        return (
            <div>
            </div>
        )
    }
}

export default Volleyball;